import { ActionTree } from 'vuex';
import ExamAPI from '../api/ExamAPI';
import AnswerAPI from '../api/AnswerAPI';
import { ExamState } from './types';
import { RootState } from '../types';

export const actions: ActionTree<ExamState, RootState> = {
  async loadData ({ commit, state }) {
    const data = await ExamAPI.loadDataAsyn();
    commit("loadData", data);
    try {
      let current_question = location.href.split("#")[1].split("-")[1];
      if (!isNaN(Number(current_question))) {
        commit("showQuestion", {index: Number(current_question)})
      } else {
        history.replaceState( {} , null, `${location.href.split("#")[0]}#question-0`);
      }
    } catch {
      history.replaceState( {} , null, `${location.href.split("#")[0]}#question-0`);
    }
    if (state.timer > 0) {
      state.counter = setInterval(function() {
        commit("countdown");
      }, 1000) as any;
    }
  },

  async updateAnswer ({ commit, state }, payload) {
    const question = state.questions.find((question) => question.id == payload.questionId)
    const data = await AnswerAPI.create(question, {answersParams: payload.answer})
    commit("updateAnswer", {questionId: question.id, answers: data})
  },

  async finishExam ({ commit, state }, payload) {
    const data = await ExamAPI.finish(state.exam);
    if (data.callback_url) {
      window.location.href = data.callback_url;
    } else {
      window.location.reload();
    }
  },

  changeQuestion({ commit }, payload) {
    commit("pushState", payload);
    commit("showQuestion", payload);
  },

  submit ({ commit }, payload) {
    commit("setConfirmSubmit", { confirmSubmit: true });
  },

  cancelSubmit ({ commit, state }, payload) {
    commit("setConfirmSubmit", { confirmSubmit: false });
  }
}
